/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import Label from 'material/embeds/labelassignmentfield/field/label/label';
import Info from 'material/embeds/labelassignmentfield/field/info/info';
import ErrorMessage from 'material/embeds/labelassignmentfield/field/errormessage/errormessage';
// utils
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/labelassignmentfield/field/field_styles';



/* ========== ~~~~~~~~~~ EXPORT : FORM : FIELD ~~~~~~~~~~ ========== */
const Field = (props) => {

    /////  ~~~~~~~~~~~ ---------- ~~~~~~~~~~~~  DISPLAY  ~~~~~~~~~~~ ---------- ~~~~~~~~~~~~  /////
	const displayLabel = () => {
		return props.label ? <Label>{props.label}</Label> : null;
	};
	const displayIcon = () => {
		return props.icon ? <span className={`fieldicon`}>{props.icon}</span> : null;
	};
	const displayInfo = () => {
		return props.info ? <Info>{props.info}</Info> : null;
	};
	const displayErrorMessage = () => { // Need to pass the results of getErrorMessage down as prop to Field for this function from Everyone
		return !props.required ? null : props.valid === false ? <ErrorMessage>{props.errorMessage}</ErrorMessage> : null;
	};

	return (
			<div className={`field isActive-${props.active} disabled-${props.disabled} isValid-${props.valid} hasValue-${props.hasValue} ${props.classes.field}`}>
				{displayLabel()}
				{props.test}
	        	<div className={`formelement`}>
	        		{displayIcon()}
	        		<span className={`element`}>{props.component}</span>
	        	</div>
	        	{displayInfo()}
	        	{displayErrorMessage()}
	        </div>
		);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Field);
